import { Link } from 'react-router-dom';
import SectionHeader from './SectionHeader';
import { PRODUCTS, productDemoPath } from '../config/site';

const enterprise = PRODUCTS.filter((p) => p.pagePath && p.challenge && p.outcome);

export default function ProductOutcomesSection() {
  return (
    <section className="section section--band outcomes-section">
      <div className="container">
        <SectionHeader
          creative
          light
          align="center"
          label="Outcomes"
          title="Problem → platform → result"
          description="Each product addresses a specific operator challenge — with architecture and demos tailored to your environment."
        />
        <div className="outcomes-list">
          {enterprise.map((product) => (
            <article
              key={product.id}
              className="outcome-row"
              style={{ '--product-accent': product.accent }}
            >
              <div className="outcome-row__meta">
                <p className="outcome-row__challenge">{product.challenge}</p>
                <h3>{product.name}</h3>
                <p className="outcome-row__result">{product.outcome}</p>
              </div>
              <div className="outcome-row__actions">
                <Link to={product.pagePath} className="btn btn--product">
                  Explore {product.name}
                </Link>
                <Link to={productDemoPath(product.id)} className="btn btn--secondary">
                  Request demo
                </Link>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}
